import { Badge } from "@/components/ui/badge";

interface ScoreBadgeProps {
  score?: number;
  maxScore?: number;
}

export function ScoreBadge({ score, maxScore = 100 }: ScoreBadgeProps) {
  if (score === undefined) {
    return (
      <Badge variant="outline" className="bg-gray-100 text-gray-600">
        Not Analyzed
      </Badge>
    );
  }

  const percentage = (score / maxScore) * 100;

  const getColor = () => {
    if (percentage >= 80)
      return "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200";
    if (percentage >= 60)
      return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200";
    if (percentage >= 40)
      return "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200";
    return "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200";
  };

  return (
    <Badge className={getColor()}>
      {score}/{maxScore}
    </Badge>
  );
}
